export const truncateText = (text, maxLength) => {
  if (!text) return "";
  if (typeof text !== "string") {
    text = String(text);
  }
  if (!maxLength || maxLength <= 0) {
    return text;
  }
  if (maxLength <= 3) {
    return text.slice(0, maxLength);
  }
  if (text.length > maxLength) {
    return text.slice(0, maxLength - 3) + "...";
  }
  return text;
};

export  const getMBValue=(value)=> {
    const json = JSON.stringify(value);

    const blob = new Blob([json], { type: 'application/json' });
    const sizeInBytes = blob.size;
    const sizeInMB = sizeInBytes / (1024 * 1024);
    
   
  
    return sizeInMB;
  }